import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux'

import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'

import { unregister } from './registerServiceWorker'
import DI from './di'
import { toggleMock } from './env'
import * as userActions from '../model/user/actions'
import App from './App'
import { init as initPlay } from './play'

export const init = async (env: string) => {
  unregister()
  const store = DI.get('store')

  const container = document.getElementById('react-root')!
  const root = createRoot(container)
  root.render(
    <ReduxProvider store={store}>
      <DndProvider backend={HTML5Backend}>
        <App env={env} />
      </DndProvider>
    </ReduxProvider>,
  )

  if (!window.location.hash.startsWith('#/creative-preview')) {
    store.dispatch({ type: '@INIT' })
    store.dispatch(userActions.getUser())
  }

  if (env === 'development') {
    const assigns = initPlay(DI)
    // Of course property doesn't yet exist. We are creating it.
    // @ts-ignore
    window.Play = {
      ...assigns,
      toggleMock,
      DI,
    }
  }
}

export default init
